export default "__VITE_ASSET__b263b824__"